module.exports = __webpack_public_path__ + "img/visa.ce1babe.png";